import { Swiper as SliderContainer, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// @interfaces
import styles from '../styles/pages/estimation/CompensationTips.module.css';
import "swiper/css";
import "swiper/css/pagination";


const CompensationTips: React.FC = () => {

  const tips = [
    {
      name: 'Calculate your carbon footprint',
      description: 'Everyday activities like travel release carbon emissions into the atmosphere. These gases trap heat, which is a key driver of climate change.'
    },
    {
      name: 'Fund carbon projects',
      description: 'Purchase carbon credits equal to your emissions. The money funds carbon projects that reduce, avoid or remove emissions elsewhere. Funding carbon projects doesn’t cancel your emissions.'
    },
    {
      name: 'Trace your contribution',
      description: 'Trace your contribution to the carbon projects it funds. A summary of your contribution and the projects it funds will go straight to your email inbox.'
    }
  ];

  return (
    <SliderContainer
      modules={[Pagination]}
      pagination={{ clickable: true }}
      className={styles.carouselContainer}
    >
      {tips.map((tip: any, index: number) => {
        return (
          <SwiperSlide
            className={styles.carouselItem}
            key={index}
          >
            <div
              className={styles.carouselImg}
            >
              <p className={styles.tipName}>{tip.name}</p>
              <p className={styles.tipDescription}>{tip.description}</p>
            </div>
          </SwiperSlide>
        );
      })}
    </SliderContainer>
  )
};

export default CompensationTips;
